import React from 'react';
// template components
import BulletedList from '@nmx/template/dist/componentLibrary/components/BulletedList';
import Col from '@nmx/template/dist/componentLibrary/foundations/Grid/Col';
import Link from '@nmx/template/dist/componentLibrary/components/Link';
import Row from '@nmx/template/dist/componentLibrary/foundations/Grid/Row';
import SectionContainer from '@nmx/template/dist/componentLibrary/components/SectionContainer';
import Typography from '@nmx/template/dist/componentLibrary/foundations/Typography';

export default () => (
  <SectionContainer
    id='life-insurance-faq-submit-waiver-premium-claim'
    backgroundVariant='lightA'
    themeType='lightTheme'>
    <Row align='center'>
      <Col medium={8}>
        <Typography
          component='h2'
          nextElement='typography'
          align='center'>
          Submit a Death Claim
        </Typography>
        <Typography nextElement='typography'>
          The loss of a loved one places a tremendous emotional burden on the surviving family members. That&#39;s why we&#39;ve made our life insurance claim service quick and straightforward.
        </Typography>
        <Typography nextElement='typography'>
          We&#39;ll tell you what settlement options you have for the proceeds and the steps you need to take.
        </Typography>
        <Typography
          component='h3'
          nextElement='typography'>
          Report the Death
        </Typography>
        <Typography nextElement='typography'>
          Complete and submit the <Link
            linkUrl='/report-a-death/'
            variant='primaryDeemphasize'>
            Report of Insured&#39;s Death form
          </Link> or notify your Northwestern Mutual financial representative. Information and forms will be provided to the beneficiary of record or the beneficiary&#39;s representative that will guide them on how to process the death claim.
        </Typography>
        <Typography nextElement='typography'>
          If you are making an inquiry to determine if a deceased family member had coverage at Northwestern
          Mutual please contact us by phone at <Link id='life-insurance-faq-submit-atoll-free-number-link'
            ariaLabel='Call to inquiry if a deceased family member had coverage at Northwestern Mutual' linkUrl='tel:8003888123' variant='primaryDeemphasize'>&#40;800&#41; 388&#45;8123</Link> or by fax <Link id='life-insurance-faq-submit-atoll-free-number-link' ariaLabel='Fax to inquiry if a deceased family member had coverage at Northwestern Mutual' linkUrl='tel:4146259000' variant='primaryDeemphasize'>&#40;414&#41; 625&#45;9000</Link>.
        </Typography>
        <Typography
          component='h3'
          nextElement='typography'>
          Policy Proceeds
        </Typography>
        <Typography nextElement='typography'>
          Proceeds are payable to the beneficiary upon the death of the insured, as stated under the
          terms of the life insurance policy.
        </Typography>
        <Typography nextElement='typography'>
          Beneficiaries can receive proceeds several ways:
        </Typography>
        <BulletedList
          bulletedListData={[
            { bulletText: 'The beneficiary can receive the proceeds in a single check.' },
            { bulletText: 'The beneficiary can choose from several other settlement options.' },
          ]}
        />
        <Typography
          component='h3'
          nextElement='typography'>
          Settlement Plans
        </Typography>
        <Typography nextElement='typography'>
          There are several kinds of settlement choices available to beneficiaries, including lump
          sum, interest income, period certain for a set number of years, life income plan or a Joint Life
          income plan. Our plans are designed to provide flexibility allowing you to preserve benefits while
          earning interest; receive income over a specified period, or receive income over a lifetime. Choices
          are subject to availability and can be discontinued at any time. Plans are subject to individual
          contracts and market types.
        </Typography>
        <Typography nextElement='typography'>
          The settlement choice selected should be based on an individual&#39;s financial circumstances, risk
          tolerance and return potential.
        </Typography>
        <Typography
          component='h3'
          nextElement='typography'>
          Planning Your Future
        </Typography>
        <Typography nextElement='typography'>
          Northwestern Mutual offers the following guides to assist you in gathering personal
          information for planning for your future.
        </Typography>
        <Typography nextElement='typography'>
          Get tips for locating a missing policy from <Link
            linkUrl='https://www.acli.com/Consumers/Life%20Insurance/Pages/Missing%20Policy%20Tips.aspx'
            isOutgoingLink
            variant='primaryDeemphasize'>
            The American Council of Life Insurers
          </Link>.&#42;
        </Typography>
        <Typography disableBottomPadding>
          &#42;When you access this site, you will be leaving our site. Northwestern Mutual is not responsible for the accuracy of information on <Link linkUrl="https://www.northwesternmutual.com/third-party-links/" variant='primaryDeemphasize'>third-party sites</Link>. Reference to another site is for informational purposes only. Please review this site carefully,
          some services offered at this site charge a fee. Northwestern Mutual receives no remuneration for
          the website link in this article.
        </Typography>
      </Col>
    </Row>
  </SectionContainer>
);
